import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EcoIcon from '@material-ui/icons/Eco';
import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import NatureIcon from '@material-ui/icons/Nature';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import OpacityIcon from '@material-ui/icons/Opacity';
import CheckIcon from '@material-ui/icons/Check';
import Section from './Section';
import Reveal from './Reveal';
import { services } from '../siteConfig';
import { colors } from '../theme';

const icons = {
  eco: EcoIcon,
  naturePeople: NaturePeopleIcon,
  nature: NatureIcon,
  cleanup: DeleteSweepIcon,
  fence: ViewColumnIcon,
  water: OpacityIcon,
};

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: theme.spacing(4),
    border: '1px solid rgba(14,35,64,0.08)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 16px 40px rgba(14,35,64,0.10)',
      borderColor: 'rgba(31,122,90,0.3)',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  icon: {
    width: 56,
    height: 56,
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.green,
    color: '#FFFFFF',
    marginBottom: theme.spacing(2.5),
    '& svg': { fontSize: 30 },
  },
  title: {
    color: colors.navy,
    marginBottom: theme.spacing(1.5),
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    color: theme.palette.text.secondary,
    padding: '4px 0',
  },
  check: {
    color: colors.green,
    fontSize: 20,
    marginTop: 3,
  },
  cta: {
    textAlign: 'center',
    marginTop: theme.spacing(6),
  },
}));

export default function Services() {
  const classes = useStyles();

  return (
    <Section
      id="services"
      background="sand"
      eyebrow="What we do"
      title="Services for every corner of your property"
      subtitle="From weekly mowing to a brand-new lawn, we handle the work so you can enjoy your yard."
    >
      <Grid container spacing={3}>
        {services.map((service, index) => {
          const Icon = icons[service.icon];
          return (
            <Grid item xs={12} sm={6} md={4} key={service.title}>
              <Reveal delay={(index % 3) * 100}>
                <div className={classes.card}>
                  <div className={classes.icon}>
                    <Icon />
                  </div>
                  <Typography variant="h6" component="h3" className={classes.title}>
                    {service.title}
                  </Typography>
                  <ul className={classes.list}>
                    {service.items.map((item) => (
                      <li key={item} className={classes.listItem}>
                        <CheckIcon className={classes.check} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            </Grid>
          );
        })}
      </Grid>
      <div className={classes.cta}>
        <Button variant="contained" color="primary" size="large" href="#contact">
          Request a free estimate
        </Button>
      </div>
    </Section>
  );
}
